// @flow
import React from 'react';
import { useFormikContext } from 'formik';

import { PrimaryButton } from '../presentational/buttons/PrimaryButton';
import { useEstimateRateCardVersion } from '../../custom-hooks/useEstimateRateCardVersion';
import { useIsEstimateRenewal } from '../../custom-hooks/useIsEstimateRenewal';

import {
  getConfiguredMetricRowsFromFormikValuesForEstimateCC,
  getIfAnyRowIsBeingEditedAnyWhereInAnyMetricForEstimateCC,
  getIfAnyRowMetricNameIsNullForEstimateCC,
  getUnusedMetricsListForEstimateCC,
} from './utils';

export const EstimateCommittedCapacityAddNewMetricButton = ({ metricDimensionRefs }) => {
  const { values: formikValues } = useFormikContext();
  const configuredMetricRows = getConfiguredMetricRowsFromFormikValuesForEstimateCC(formikValues);
  const rateCardVersion = useEstimateRateCardVersion();
  const isRenewal = useIsEstimateRenewal();
  const unusedMetricsList = getUnusedMetricsListForEstimateCC(
    configuredMetricRows,
    rateCardVersion,
    isRenewal
  );

  // User should not be able to add a new metric when there is work happening on any row in the already added metric
  // Also, when the user has clicked on Add Metric and has not chosen a metric yet, it should be disabled
  // Finally, if there are no more metrics to be configured, we need to disable it
  const shouldAddMetricBeDisabled =
    getIfAnyRowIsBeingEditedAnyWhereInAnyMetricForEstimateCC(configuredMetricRows) ||
    getIfAnyRowMetricNameIsNullForEstimateCC(configuredMetricRows) ||
    unusedMetricsList.length === 0;

  return (
    <PrimaryButton
      disabled={shouldAddMetricBeDisabled}
      floated="right"
      onClick={() => {
        const newRow = {
          metricName: null,
          metricId: '-1',
        };
        return metricDimensionRefs.current.metricLevelArrayHelpers.push(newRow);
      }}
      text="+ Add Metric"
    />
  );
};
